import React, { useState } from "react";
import {
  Box,
  Text,
  Flex,
  Button,
  Divider,
  Image,
  Checkbox,
  Input,
  Spinner,
  useDisclosure,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";

import Topbar from "components/topbar";
import MainLayout from "components/mainLayout";
import FormikInput from "components/formikInput";
import dumyImage from "assets/marketing-image.png";
import FormikTextArea from "components/formikTextArea";
import { useShipmentForm } from "context/DHLShipmentFormContext";
import TextInput from "./components/TextInput";
import CustomTextInput from "components/textInput";
import useGetServicePointLocation from "api/queries/useGetServicePointLocation";
import ShipmentSummaryModal from "./ShipmentSummaryModal";

const DhlDropLocation = () => {
  const navigate = useNavigate();
  const { formData, updateFormData } = useShipmentForm();
  const [postalCode, setPostalCode] = useState(
    formData?.dropoff?.servicePoint?.postalCode
  );
  const [selectLocation, setSelectLocation] = useState(false);
  const [selectedLocationIndex, setSelectedLocationIndex] = useState(null);
  const {
    isOpen: isSummaryModalOpen,
    onOpen: onSummaryModalOpen,
    onClose: onSummaryModalClose,
  } = useDisclosure();

  const { data, isLoading, error, refetch, isFetching } =
    useGetServicePointLocation({
      postalCode: postalCode,
      countryCode: "GB",
    });

  return (
    <MainLayout>
      <Flex minH={"100%"} h={"100%"} bg={"#f8fbff"} flexDirection={"column"}>
        <Topbar title={"SHIP THROUGH DHL"} />
        <Flex
          flex={1}
          direction={"column"}
          bg={"#FFFFFF"}
          margin={4}
          padding={6}
          borderRadius={"16px"}
          gap={6}
        >
          <Text
            fontFamily={"PlusJakartaSansSemiBold"}
            fontSize={"24px"}
            lineHeight={"32px"}
            textTransform={"capitalize"}
            color={"#000000"}
          >
            Create Shipment
          </Text>
          <Divider bg={"#8A8F9333"} h={"1px"} />

          <Box>
            <Flex flexDirection={"column"} gap={6}>
              <Box>
                <Text
                  color={"#000000"}
                  fontFamily="PlusJakartaSansSemiBold"
                  fontSize={"16px"}
                  lineHeight={"22px"}
                  textTransform={"capitalize"}
                  mb={2}
                >
                  Send Details
                </Text>
                <Box
                  border="1px solid #D9D9D9"
                  borderRadius="8px"
                  p={4}
                  gap={4}
                  display={"flex"}
                  flexDirection={"column"}
                >
                  <CustomTextInput
                    // formik={formik}
                    name="postcode"
                    placeholder={"Enter Postcode"}
                    label={"Postcode"}
                    labelColor={"#000000"}
                    onChange={(e) => setPostalCode(e.target.value)}
                    value={postalCode}
                  />
                  {data?.locations?.lenght !== 0 && (
                    <Box>
                      <Text
                        color={"#000000"}
                        fontFamily="PlusJakartaSansMedium"
                        fontSize={"12px"}
                        lineHeight={"22px"}
                        textTransform={"capitalize"}
                        mb={2}
                      >
                        Nearby DHL Service Point
                      </Text>
                      {isLoading ? (
                        <Flex justifyContent={"center"} alignItems={"center"}>
                          <Spinner />
                        </Flex>
                      ) : (
                        <Box
                          border="1px solid #D9D9D9"
                          borderRadius="8px"
                          p={4}
                          gap={4}
                          display={"flex"}
                          flexDirection={"column"}
                          maxH="270px" // adjust height to fit approximately 3 inputs
                          overflowY="auto"
                        >
                          {!data?.locations ||
                          data.locations.length === 0 ||
                          data === undefined ? (
                            <Text
                              fontFamily={"PlusJakartaSansSemiBold"}
                              fontSize={"16px"}
                              color={"#000000"}
                              textAlign={"center"}
                            >
                              No Location Found
                            </Text>
                          ) : (
                            data?.locations?.map((item, index) => {
                              return (
                                <Flex alignItems={"center"} gap={8}>
                                  <Checkbox
                                    isChecked={selectedLocationIndex === index}
                                    onChange={(value) => {
                                      if (value?.target?.checked) {
                                        setSelectedLocationIndex(index);
                                        updateFormData({
                                          dropoff: {
                                            howTo: formData?.dropoff?.howTo,
                                            servicePoint: {
                                              postalCode:
                                                item?.place?.address
                                                  ?.postalCode,
                                              countryCode:
                                                item?.place?.address
                                                  ?.countryCode,
                                              point: {
                                                id:
                                                  item?.location &&
                                                  item?.location?.ids[0]
                                                    ?.locationId,
                                                name: item?.name,
                                                address:
                                                  item?.place?.address
                                                    ?.streetAddress,
                                              },
                                            },
                                            ...(formData?.dropoff
                                              ?.notifications || {}),
                                          },
                                        });
                                        setSelectLocation(!selectLocation);
                                      } else {
                                        setSelectedLocationIndex(null);
                                        updateFormData({
                                          dropoff: {
                                            ...formData?.dropoff,
                                          },
                                        });
                                        setSelectLocation(!selectLocation);
                                      }
                                    }}
                                  />
                                  {/* Address Details */}
                                  <Flex
                                    flex="1"
                                    justifyContent={"space-between"}
                                    alignItems={"center"}
                                  >
                                    <Flex flexDir={"column"}>
                                      <Text
                                        fontFamily={"PlusJakartaSansMedium"}
                                        fontSize={"16px"}
                                        color={"#1E1E1E"}
                                      >
                                        {item.name}
                                      </Text>
                                      <Text
                                        fontFamily={"PlusJakartaSansMedium"}
                                        fontSize={"14px"}
                                        color={"#898989"}
                                      >
                                        {item?.place?.address?.streetAddress},{" "}
                                        {item?.place?.address?.postalCode}
                                      </Text>
                                    </Flex>
                                    <Text
                                      fontFamily={"PlusJakartaSansMedium"}
                                      fontSize={"14px"}
                                      color={"#898989"}
                                    >
                                      {item?.place?.address?.streetAddress},{" "}
                                      {item?.place?.address?.postalCode}
                                    </Text>
                                    <Text
                                      fontFamily={"PlusJakartaSansMedium"}
                                      fontSize={"14px"}
                                      color={"#898989"}
                                    >
                                      {item?.place?.address?.addressLocality}
                                    </Text>
                                  </Flex>
                                </Flex>
                              );
                            })
                          )}
                        </Box>
                      )}
                    </Box>
                  )}
                </Box>
              </Box>
            </Flex>
          </Box>

          <Flex mt={4} gap={2} flex={1} alignItems={"flex-end"}>
            <Flex>
              <Button
                onClick={() => navigate(-1)}
                width={"148px"}
                borderRadius={8}
                bg={"none"}
                border={"1px solid #000000"}
                color={"#000000"}
                fontSize={"12px"}
                fontWeight={"500"}
                fontFamily={"PlusJakartaSansMedium"}
                letterSpacing={0.2}
              >
                Back
              </Button>
            </Flex>
            <Flex justifyContent={"flex-end"} flex={1} w={"100%"} gap={2}>
              <Button
                onClick={() => {
                  if (formData?.dropoff?.howTo === "printer") {
                    onSummaryModalOpen();
                  } else {
                    navigate("/send-a-bag/dhl/email");
                  }
                }}
                flex={1}
                maxW={"148px"}
                background={"#000000"}
                color={"#FFFFFF"}
                borderRadius={8}
                fontSize={"12px"}
                fontFamily={"PlusJakartaSansMedium"}
                textTransform={"uppercase"}
                isDisabled={!selectLocation}
              >
                Next
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <ShipmentSummaryModal
        isOpen={isSummaryModalOpen}
        onClose={onSummaryModalClose}
      />
      "
    </MainLayout>
  );
};

export default DhlDropLocation;
